import React from 'react';
import CoffeeChatQuestionManagement from '../coffeechat/CoffeeChatQuestionManagement';
import { AdminPage, AdminPageHeader, AdminPageTitle, AdminSection } from '../common/AdminPrimitives';

const QuestionManagementComponent: React.FC = () => {
  return (
    <AdminPage>
      <AdminPageHeader>
        <AdminPageTitle>커피챗 질문 답변 관리</AdminPageTitle>
      </AdminPageHeader>
      <AdminSection>
        <CoffeeChatQuestionManagement />
      </AdminSection>
    </AdminPage>
  );
};

export default QuestionManagementComponent;
